export default __webpack_public_path__ + "static/media/ModernEra-ExtraBold.40cb952a.woff";